export var ComplianceDocumentType;
(function (ComplianceDocumentType) {
    ComplianceDocumentType[ComplianceDocumentType["CookieConsent"] = 1] = "CookieConsent";
    ComplianceDocumentType[ComplianceDocumentType["PrivacyPolicy"] = 2] = "PrivacyPolicy";
    ComplianceDocumentType[ComplianceDocumentType["PersonalDataProcessingConsent"] = 3] = "PersonalDataProcessingConsent";
})(ComplianceDocumentType || (ComplianceDocumentType = {}));
